import { baseApi } from "./base-api"
import { featureFlagApi } from "./feature-flag-api"

export interface EarlyAccessFeatureFlag {
  name: string
  title: string
  blurb: string
  enabled: boolean
  magic_hash?: string
}

interface GetEarlyAccessFeatureFlagsResponse {
  feature_flags: EarlyAccessFeatureFlag[]
}

interface SetEarlyAccessFeatureFlagResponse {
  feature_flag: EarlyAccessFeatureFlag
}

export const earlyAccessApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getEarlyAccessFeatureFlags: builder.query<EarlyAccessFeatureFlag[], void>({
      query: () => ({
        url: "/api/feature_flags/early_access",
      }),
      transformResponse: (response: GetEarlyAccessFeatureFlagsResponse) =>
        response.feature_flags,
      providesTags: ["EarlyAccessFeatureFlags"],
    }),
    previewEarlyAccessFeature: builder.query<EarlyAccessFeatureFlag, string>({
      query: (hash) => ({
        url: `/api/feature_flags/early_access/preview/${encodeURIComponent(hash)}`,
      }),
      transformResponse: (response: SetEarlyAccessFeatureFlagResponse) =>
        response.feature_flag,
    }),
    optInEarlyAccessFeature: builder.mutation<EarlyAccessFeatureFlag, string>({
      query: (hash) => ({
        url: `/api/feature_flags/early_access/opt_in/${encodeURIComponent(hash)}`,
        method: "post",
      }),
      transformResponse: (response: SetEarlyAccessFeatureFlagResponse) =>
        response.feature_flag,
      invalidatesTags: ["EarlyAccessFeatureFlags"],
      async onQueryStarted(_hash, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled
          dispatch(featureFlagApi.util.invalidateTags(["FeatureFlag"]))
        } catch {
          // If the mutation fails, do nothing
        }
      },
    }),
    disableEarlyAccessFeature: builder.mutation<EarlyAccessFeatureFlag, string>(
      {
        query: (featureName) => ({
          url: `/api/feature_flags/early_access/${encodeURIComponent(featureName)}/disable`,
          method: "post",
        }),
        transformResponse: (response: SetEarlyAccessFeatureFlagResponse) =>
          response.feature_flag,
        invalidatesTags: ["EarlyAccessFeatureFlags"],
        async onQueryStarted(_featureName, { dispatch, queryFulfilled }) {
          try {
            await queryFulfilled
            dispatch(featureFlagApi.util.invalidateTags(["FeatureFlag"]))
          } catch {
            // If the mutation fails, do nothing
          }
        },
      }
    ),
  }),
})

export const {
  useGetEarlyAccessFeatureFlagsQuery,
  usePreviewEarlyAccessFeatureQuery,
  useOptInEarlyAccessFeatureMutation,
  useDisableEarlyAccessFeatureMutation,
} = earlyAccessApi
